import {Card, CardActionArea, CardContent, CardMedia, Grid, styled, Typography} from '@mui/material';
import React from 'react';
import {QuickFix} from "../../../interfaces/quickFix";

const StyledCardActionArea = styled(CardActionArea)(({theme}) => `
    .MuiCardActionArea-focusHighlight {
        background: transparent;
    }
`);

interface QuickFixDrillsProps {
    drill: QuickFix;
    last: boolean;
}

export default function QuickFixAndDrills({drill, last}: QuickFixDrillsProps) {

    return (
        <Grid container
              marginRight={{md: 3, xs: 0}}
              marginLeft={{xs: 2, md: 0}}
              marginBottom={{xs: 3, md:0}} direction="row" flexWrap={"nowrap"}
              alignItems="stretch"
              onClick={() => window.open(drill.url, "_self")}
              sx={{
                  flexDirection: "row",
                  flexWrap: "nowrap",
                  display: "flex",
                  alignItems: "stretch",
                //   minWidth: ["138px", "250px", "289px"],
                  minWidth: {xs: "205px", md: "auto"},
                  minHeight: ["174px", "189px", "248px"],
                  boxShadow: "none"
              }}>
            <Card sx={{borderRadius: '0', boxShadow: "none"}}>
                <StyledCardActionArea disableRipple>
                    <CardMedia
                        component="img"
                        image={drill.image}
                        alt={drill.name}
                        sx={{
                            borderRadius: "8px"
                        }}
                    />
                    <CardContent sx={{ padding: "0", marginTop: "8px"}}>
                        <Typography
                            sx={{
                                whiteSpace: 'break-spaces',
                                minHeight: "60px",
                                fontSize: "18px",
                                fontWeight: 500,
                                fontFamily: "Repro",
                                textTransform: "capitalize"
                            }}>{drill.name}</Typography>
                    </CardContent>
                </StyledCardActionArea>
            </Card>
        </Grid>
    )
}
